<svelte:options tag={null} />
  <script>
  export let id = undefined;
  export let style = undefined;
  export let className = undefined;
  export let fill = undefined;
  export let size = "3rem";
</script>

<svg aria-hidden="true" width={size} height={size} id={id}  style={style} class={className} fill={fill} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 48 48"><path d="M38.26 5.12l-8.13-1a1.22 1.22 0 00-.57-.12 2.76 2.76 0 00-1.37.22l-8 1.29a1.12 1.12 0 00-.9 1.1 2 2 0 00-2 0L9 11.41a2 2 0 00-.72 2.71L24.94 43a2 2 0 002.72.72L35.93 39a2 2 0 00.72-2.71l-.27-.48L40 7.33a2 2 0 00-1.74-2.21zm-9.9 2l3.32 20.56-11-19.12v-.18zM27 40.86L11.14 13.44 18 9.51l15.78 27.42zm7.58-13.2L31.23 7.08l5.84.74z"/><circle cx="27.34" cy="33.11" r="1.74"/></svg>